import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Dashboard } from '../dashboard/dashboard';
import { NgCircleProgressModule, CircleProgressComponent } from 'ng-circle-progress';
import { ClockComponent } from '../component/clock';
import { TranslateService } from '@ngx-translate/core';


/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-global_statistiche',
  templateUrl: 'global_statistiche.html', 
})
export class Global_Statistiche extends Util {
  statistiche: any;
  language = 'it';
  @ViewChild('xsd') progress: CircleProgressComponent;
  constructor(public navCtrl: NavController,public translate: TranslateService, public navParams: NavParams, injector: Injector, loading: LoadingController,clock: ClockComponent) {
    super(injector, loading);
    // this.user = this.navParams.get('user');
    // this.mj = this.navParams.get('mj');
    
    // console.log('---statistiche:',this.statistiche);
    //this.refreshpage(this.mj);
    this.statistiche = this.navParams.get('statistiche');
    this.language = this.translate.getDefaultLang();
  }
  ionViewCanEnter(){
    //this.progress.animate();
    //this.progress.draw(60);
    //this.progress.render();
  }
   
  button_action(){
    // console.log(this.progress);
    
    this.progress.draw(52);
  }


  back(){
    this.navCtrl.pop({animate:false});
  }
  go_root(){
    this.navCtrl.setRoot(Dashboard);
  }
}



// WEBPACK FOOTER //
// ./src/pages/global_statistiche/global_statistiche.ts